/**
 * Clamps a numeric value between the min and max values.
 */
export const clamp = (value: number, min: number, max: number) => {
    return Math.min(max, Math.max(value, min));
};

export default clamp;
